// Catalog pages bundle (smaller catalog controllers)
import '../css/pages/catalog/event-calendar/index.css';
import '../css/pages/catalog/music-date-planner/index.css';
import '../css/pages/catalog/contact/index.css';
import '../css/pages/catalog/teaching-music/index.css';
import '../css/pages/catalog/sacred-music/index.css';
import '../css/pages/catalog/reading-session/registration.css';
import '../css/pages/catalog/product-line-reprint-box/reprints.css';
import '../css/pages/catalog/artist-catalog/list-artists.css';
import '../css/pages/catalog/artist-catalog/artist-bio.css';
import '../css/pages/catalog/pay-invoice/index.css';

import { runLegacy, runLegacyIf } from './helpers/load-legacy';
import bootboxJs               from '../js/vendor/bootbox.min.js?legacy';
import teachingMusicJs         from '../js/pages/catalog/teaching-music/index.js?legacy';
import reprintsJs              from '../js/pages/catalog/product-line-reprint-box/reprints.js?legacy';
import musicDatePlannerJs      from '../js/pages/catalog/music-date-planner/index.js?legacy';
import contactJs               from '../js/pages/catalog/contact/index.js?legacy';
import handbellsSearchJs       from '../js/pages/catalog/handbells-search/index.js?legacy';

// Guarded: registration.js calls updatePrice() which references isFee,
// a template-injected global on the reading-session/registration page.
import readingSessionJs        from '../js/pages/catalog/reading-session/registration.js?legacy';

runLegacy(
    bootboxJs,
    teachingMusicJs,
    reprintsJs,
    musicDatePlannerJs,
    contactJs,
    handbellsSearchJs,
);

runLegacyIf(() => typeof window.isFee !== 'undefined', readingSessionJs);
